// @flow

export const WHITEBOARD_OPEN_COMMAND = 'whiteboard-open';

export const WHITEBOARD_CLOSE_COMMAND = 'whiteboard-close';